import 'core-js/fn/array';
import 'core-js/fn/string';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import Raven from 'raven-js'
import ReactGA from 'react-ga';

ReactGA.initialize('UA-67642515-5');
ReactGA.pageview(window.location.pathname + window.location.search);

if (process.env.REACT_APP_RAVEN_DSN) {
    Raven.config(process.env.REACT_APP_RAVEN_DSN).install();
}
ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js